import LTR from "@brand-icons/global/social-viber/social-viber-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialViberIcon = iconFactory("SocialViberIcon", LTR);
